import React from 'react'
import './experience.css'
import { BsPatchCheckFill } from 'react-icons/bs'
import { experiences } from '../../data/data'

function Experience() {
  return (
    <section id='experience'>
      <h5>What Skills I have</h5>
      <h2>My Experience</h2>

      <div className='container experience__container'>
        <div className='experience__container-left'>
          <div className='experience__group'>
            <h3>Frontend Stack</h3>
            <div className='experience__content'>
              {experiences.frontend.map((exp, i) => (
                <Skill {...exp} key={i + 1} />
              ))}
            </div>
          </div>
          <div className='experience__group'>
            <h3 className='experience__tool-header'>Tools Stack</h3>
            <div className='experience__content'>
              {experiences.tools.map((t, i) => (
                <Skill {...t} key={i} />
              ))}
            </div>
          </div>
        </div>
        <div className='experience__group'>
          <h3>Backend Stack</h3>
          <div className='experience__content'>
            {experiences.backend.map((exp, i) => (
              <Skill {...exp} key={i + 1} />
            ))}
          </div>
        </div>
      </div>
    </section>
  )
}

const Skill = ({ skill, level, tool, frequency, icon }) => {
  return (
    <article className='experience__details'>
      {icon}
      <h4>{skill || tool}</h4>
    </article>
  )
}

export default Experience
